module.exports = __webpack_public_path__ + "static/media/image-not-found.6017e4da.jpg";